import { render, staticRenderFns } from "./FrameImage.vue?vue&type=template&id=080fa194&"
import script from "./FrameImage.vue?vue&type=script&lang=js&"
export * from "./FrameImage.vue?vue&type=script&lang=js&"
import style0 from "./FrameImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FrameImage.vue"
export default component.exports